export const SLICING_DONE_LIST_REQUEST = "SLICING_DONE_LIST_REQUEST";
export const SLICING_DONE_LIST_SUCCESS = "SLICING_DONE_LIST_SUCCESS";
export const SLICING_DONE_LIST_FAILED = "SLICING_DONE_LIST_FAILED";
